import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import { Select } from '@pella/sash-framework';

const PLPFilterSort = (props) => {
	const [tileSort, setTileSort] = props.tileSort;
	const handleTileSort = (e) => {
		setTileSort(e.target.value);
	};

	useEffect(() => {
		const queryParams = queryString.parse(window.location.search);
		const params = new URLSearchParams(queryParams);
		params.set('sort', tileSort);
		window.history.replaceState({}, '', `${location.pathname}?${params}`);
	}, [tileSort]);

	return (
		<Select
			id='tileSort'
			name='tileSort'
			labelText='Sort By:'
			onChange={handleTileSort}
			value={tileSort}
			groupClass={'xl:w-fit !mb-0 xl:ml-auto'}
		>
			<option value='recommended'>Recommended</option>
			<option value='price-low-high'>Price: Low to High</option>
			<option value='price-high-low'>Price: High to Low</option>
		</Select>
	);
};

PLPFilterSort.propTypes = {
	tileSort: PropTypes.array,
};

export default PLPFilterSort;
